/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomAddActionCard from '../../../../common/components/CustomAddActionCard/CustomAddActionCard';
import { Box, Grid, Typography } from '@mui/material';
import _ from 'lodash';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import { fonts, themes } from '../../../../common/themes/themes';
import AirTicketTile from '../../../../common/components/AirTicketTile/AirTicketTile';
import ApplyAirTicketController from '../../../../common/Modals/Claims/ApplyAirTicket/ApplyAirTicketController';
import AirTicketViewModalContoller from '../../../../common/Modals/Claims/AirTicketViewModal/AirTicketViewModalContoller';
import CustomAddButton from '../../../../common/components/CustomAddButton/CustomAddButton';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import {
  check_user_permission,
} from '../../../../common/configs/utils';
import { useAppSelector } from '../../../../infra/hooks';
interface propsType {
  airTicketsData: any;
  isLoading?: boolean;
  trans?: any;
}

const AirTikcetsPresenter: React.FC<propsType> = ({
  airTicketsData,
  isLoading,
  trans,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [airticketViewModalData, setAirticketViewModalData] = useState({});
  const auth_permissions = useAppSelector(
    (state: any) => state.authPermissionSlice?.authPermission,
  );
  return (
    <>
      <CustomAddActionCard
        card_title={trans('Air Tickets')}
        card_height="343px"
        onClick={() => setOpenModal(true)}
        card_subtitle={`${trans('Total')} : ${airTicketsData.length}`}
      >
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <div>
            {airTicketsData.length > 0 ? (
              _.map(airTicketsData, (air: any, index) => {
                return (
                  <div key={index}>
                    <Box style={{ marginBottom: '24px' }} />
                    <AirTicketTile
                      ticketName={air?.trip_type?.name}
                      startDate={air?.date}
                      endDate={air?.return_date ? air?.return_date : '--'}
                      applicant={trans(air?.ticket_for)}
                      status={air?.status}
                      onClick={() => {
                        setAirticketViewModalData(air);
                        setOpenViewModal(true);
                      }}
                    />
                  </div>
                );
              })
            ) : (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <img src={emptyIcon} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Not Applied')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.subtitle,
                      color: themes.defaultIcon,
                    }}
                  >
                    {trans('Currently you haven’t any Air Ticket Applications')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                    marginTop: '1em',
                  }}
                >
                  {check_user_permission(auth_permissions, true, 'add') ? (
                    <CustomAddButton
                      btnLabel={trans('Apply Air Ticket')}
                      onClick={() => setOpenModal(true)}
                    />
                  ) : (
                    <></>
                  )}
                </Grid>
              </Grid>
            )}
          </div>
        )}
      </CustomAddActionCard>

      {/* Apply Air Ticket Modal */}

      {openModal && (
        <ApplyAirTicketController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
        />
      )}

      {/* View Air Ticket Modal */}

      {openViewModal && (
        <AirTicketViewModalContoller
          isModalOpen={openViewModal}
          closeModal={() => setOpenViewModal(false)}
          airticketViewData={airticketViewModalData}
        />
      )}
    </>
  );
};

export default AirTikcetsPresenter;
